var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1042.766,
    height: 966.523,
    viewBox: "0 0 1042.766 966.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1099.234 -440.077)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1099.234 440.077)",
    fill: "none",
    stroke: "#0066f5",
    strokeWidth: 1,
    strokeDasharray: 5,
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383,0H746a20,20,0,0,1,20,20V383A383,383,0,0,1,383,766h0A383,383,0,0,1,0,383v0A383,383,0,0,1,383,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,.5H746A19.5,19.5,0,0,1,765.5,20V383A382.5,382.5,0,0,1,383,765.5h0A382.5,382.5,0,0,1,.5,383v0A382.5,382.5,0,0,1,383,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1376 640.6)",
    fill: "none",
    stroke: "#7a8599",
    strokeWidth: 1,
    strokeDasharray: 5,
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383,0H746a20,20,0,0,1,20,20V383A383,383,0,0,1,383,766h0A383,383,0,0,1,0,383v0A383,383,0,0,1,383,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,.5H746A19.5,19.5,0,0,1,765.5,20V383A382.5,382.5,0,0,1,383,765.5h0A382.5,382.5,0,0,1,.5,383v0A382.5,382.5,0,0,1,383,.5Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBg);
export default __webpack_public_path__ + "static/media/singleBg.35318751d74f860ac9199b2ba251bd2c.svg";
export { ForwardRef as ReactComponent };